<template>
  <div>
    <div v-if="type == 'terms'">
      <p style="margin-right:3px" v-if="row.terms_agree">Yes</p>
      <p style="margin-right:3px" v-else>No</p>
    </div>
    <div v-if="type == 'whitepaper'">
      <p style="margin-right:3px" v-if="row.whitepaper_agree">Yes</p>
      <p style="margin-right:3px" v-else>No</p>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    row: {
      type: Object
    },
    type: {
      type: String
    }
  },
}
</script>

<style scoped>

</style>